module.exports = "/assets/data/786663bff7d3693d6cd1fd1febd5d3ac-RG42.data.json";